import ColorsStyles from '@Styles/colors.scss';
import React from 'react';
import { ICircleObjectProps } from '../PlanView';
import Styles from '../PlanView.scss';
import { degreesToRadians, getCoordinatesOfPointOnCircle } from '../helpers';

const angles = [22.5, 67.5, 112.5, 157.5, 202.5, 247.5, 292.5, 337.5];
const bearings = [
    {
        angle: 0,
        text: 'N',
    },

    {
        angle: 45,
        text: 'NE',
    },
    {
        angle: 90,
        text: 'E',
    },
    {
        angle: 135,
        text: 'SE',
    },
    {
        angle: 180,
        text: 'S',
    },
    {
        angle: 225,
        text: 'SW',
    },
    {
        angle: 270,
        text: 'W',
    },
    {
        angle: 315,
        text: 'NW',
    },
];

const getTextRadius = (
    angle: number,
    circleRadius: number,
    isBearing = false
): number => {
    const exceptions = isBearing ? [180] : [157.5, 202.5];
    if (isBearing) {
        return exceptions.includes(angle)
            ? circleRadius + 14
            : circleRadius + 10;
    } else {
        return exceptions.includes(angle)
            ? circleRadius + 12
            : circleRadius + 5;
    }
};

const getTextAnchor = (angle: number): string => {
    if (angle >= 45 && angle <= 135) {
        return 'start';
    } else if (angle >= 225 && angle <= 315) {
        return 'end';
    }
    return 'middle';
};

const CompassComponent = (props: ICircleObjectProps) => {
    const notches = angles.map((angle) => {
        const bearing = degreesToRadians(angle);
        const lineEnd = getCoordinatesOfPointOnCircle(
            props.circleRadius,
            bearing,
            { x: props.circleCenter, y: props.circleCenter }
        );

        const radius = getTextRadius(angle, props.circleRadius);

        const textPlacement = getCoordinatesOfPointOnCircle(radius, bearing, {
            x: props.circleCenter,
            y: props.circleCenter,
        });

        return (
            <svg key={angle}>
                <line
                    x1={props.circleCenter}
                    y1={props.circleCenter}
                    x2={lineEnd.x}
                    y2={lineEnd.y}
                    stroke={ColorsStyles.ikeGradient7}
                    strokeWidth={0.5}
                    strokeOpacity={0.5}
                    key={`angleLine${angle}`}
                />
                <text
                    x={textPlacement.x}
                    y={textPlacement.y}
                    textAnchor={getTextAnchor(angle)}
                    className={Styles.compassAngleText}
                    key={`angleText${angle}`}
                >
                    {angle}&deg;
                </text>
            </svg>
        );
    });

    const bearingText = bearings.map((bearingObj) => {
        const bearing = degreesToRadians(bearingObj.angle);

        const radius = getTextRadius(
            bearingObj.angle,
            props.circleRadius,
            true
        );

        const textPlacement = getCoordinatesOfPointOnCircle(radius, bearing, {
            x: props.circleCenter,
            y: props.circleCenter,
        });
        return (
            <text
                x={textPlacement.x}
                y={textPlacement.y}
                textAnchor={getTextAnchor(bearingObj.angle)}
                className={Styles.compassBearingText}
                key={`bearingText${bearingObj.angle}`}
            >
                {bearingObj.text}
            </text>
        );
    });

    return (
        <svg>
            {notches}
            {bearingText}
        </svg>
    );
};

export const Compass = React.memo(CompassComponent);
